import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = {
  key: 0,
  class: "ml-1 text-red-500"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "?", -1)
const _hoisted_4 = ["checked", "value", "readonly", "name"]
const _hoisted_5 = {
  key: 1,
  class: "block -mt-2 text-red-500 mb-2 text-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: "relative flex items-center w-full mb-2",
          for: _ctx.name
        }, [
          _createElementVNode("span", null, [
            _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
            (_ctx.required)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, " * "))
              : _createCommentVNode("", true)
          ]),
          (_ctx.amplification)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "bg-gray-700 ml-2 text-white w-5 h-5 text-sm p-2 rounded-full inline-flex items-center justify-center cursor-pointer",
                onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showAmplification=true)),
                onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showAmplification=false))
              }, [
                _hoisted_3,
                (_ctx.amplification && _ctx.showAmplification)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "absolute top-full mt-2 left-0 z-50 block w-full mb-6 rounded text-sm bg-gray-700 p-3 text-white",
                      onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAmplification=true)),
                      onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAmplification=false))
                    }, _toDisplayString(_ctx.amplification), 33))
                  : _createCommentVNode("", true)
              ], 32))
            : _createCommentVNode("", true)
        ], 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("input", {
      class: _normalizeClass(["block h-8 w-8 mb-4 rounded border text-brand focus:ring-brand", [_ctx.readonly ? 'bg-gray-100' : '', _ctx.error ? 'border-red-500' : '']]),
      type: "checkbox",
      checked: _ctx.checked,
      value: _ctx.checked,
      readonly: _ctx.readonly,
      name: _ctx.name,
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.checked = !_ctx.checked)),
      onInput: _cache[5] || (_cache[5] = ($event: any) => {_ctx.$emit('update:modelValue', _ctx.checked); _ctx.$emit('input', $event)})
    }, null, 42, _hoisted_4),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true)
  ], 64))
}